import axios from 'axios'

// In dev: Vite proxy forwards /dev-portal → VITE_API_URL (no CORS issue)
// In production build: requests go directly to VITE_API_URL
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '',
  timeout: 30000,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('dp_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      const isLogin = error.config?.url?.includes('/auth/login')
      if (!isLogin) {
        localStorage.removeItem('dp_token')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export const devPortalLogin = (username, password) =>
  api.post('/dev-portal/auth/login', { username, password })

export const listConnectors = () =>
  api.get('/dev-portal/connectors')

export const getConnector = (filename) =>
  api.get(`/dev-portal/connectors/${encodeURIComponent(filename)}`)

export const saveConnector = (filename, content, approved = false) =>
  api.put(`/dev-portal/connectors/${encodeURIComponent(filename)}`, { content, approved })

export const uploadConnector = (file, displayName, description = '', approved = false) => {
  const form = new FormData()
  form.append('file', file)
  form.append('display_name', displayName)
  if (description) form.append('description', description)
  form.append('approved', approved ? 'true' : 'false')
  return api.post('/dev-portal/connectors', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const approveConnector = (filename, approved, approvedBy = '') =>
  api.put(`/dev-portal/connectors/${encodeURIComponent(filename)}/approve`, {
    approved,
    approved_by: approvedBy || undefined,
  })

export const deleteConnector = (filename) =>
  api.delete(`/dev-portal/connectors/${encodeURIComponent(filename)}`)

export const getConnectorUsages = (filename) =>
  api.get(`/dev-portal/connectors/${encodeURIComponent(filename)}/usages`)

export const runConnector = (filename, payload, config, code = null) =>
  api.post(`/dev-portal/connectors/${encodeURIComponent(filename)}/run`, {
    payload,
    config,
    ...(code !== null ? { code } : {}),
  })

export const runConnectorDebug = (filename, payload, config, code = null) =>
  api.post(`/dev-portal/connectors/${encodeURIComponent(filename)}/run-debug`, {
    payload,
    config,
    ...(code !== null ? { code } : {}),
  }, { timeout: 60000 })
